<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4>Visualizar Pagamento</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label>Cliente</label>
            <p>{{ state.assinatura.customer.name }}</p>
          </div>
          <div class="col-md-4">
            <label>Email</label>
            <p>{{ state.assinatura.customer.email }}</p>
          </div>
          <div class="col-md-4">
            <label>Método de Pagamento</label>
            <p>{{ state.assinatura.payment_method }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <label>Valor</label>
            <p>{{ state.assinatura.amount }}</p>
          </div>

          <div class="col-md-4">
            <label>Vencido em</label>
            <p>{{ state.assinatura.data_devido }}</p>
          </div>
        </div>
        <div class="btns_right">
          <button type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/pagamento-clinicas">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      assinatura: {
        id: "",
        customer: {
        },

      },
      erro_imagem: false,
      imagem: {},
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchPagamentos();
      }
    });
    async function fetchPagamentos() {
      try {
        const { data } = await services.pagamento.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.assinatura = data;
        if (data.due_at != null) {
          const chars = data.due_at.split('T');
          const data_completa = chars[0];
          const parts_data = data_completa.split('-');
          const data_devido = parts_data[2] + '/' + parts_data[1] + '/' + parts_data[0];
          state.assinatura.data_devido = data_devido;
        }


      } catch (error) {
        console.log(error);
      }
    }
    async function adicionarImagem(event) {
      var img = event.target.files[0];
      var objImagem = new Object();
      objImagem.file = img;
      objImagem.imagem = URL.createObjectURL(img);
      state.imagem = objImagem;
    }
    async function removerImagem() {
      state.imagem = {};
      document.querySelector('input[type="file"]').value = null;
    }
    return {
      removerImagem,
      adicionarImagem,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}

label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}

input {
  border: solid 1px #000;
}

input:focus {
  border: solid 1px #47b0a9;
}

select {
  border: solid 1px #000;
}

select:focus {
  border: solid 1px #47b0a9;
}

.btns_right {
  text-align: right;
  margin-top: 1rem;
}

.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_save:hover {
  background: #008000;
}

.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn_cancel:hover {
  background: #8f0303;
}

.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}

textarea {
  resize: none;
  border: solid 1px #000;
}

textarea:focus {
  border: solid 1px #47b0a9;
}

#pills-home-tab {
  color: #000;
}

#pills-home-tab:focus {
  color: #47b0a9;
}

#pills-profile-tab {
  color: #000000;
}

#pills-profile-tab:focus {
  color: #47b0a9;
}

.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}

tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}

thead {
  color: #000;
  text-align: center;
  background: gray;
}

td {
  color: #000;
  text-align: center;
}

.table {
  margin-top: 2rem;
}

.imagem {
  width: 100%;
  height: auto;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
}

.btn_deletar_imagem {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  margin-top: 2rem;
  background: #c4342d;
  color: #000;
  border: solid 1px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_deletar_imagem:hover {
  background: #8f0303;
  border: solid 1px #000;
}
</style>